export const contactGroupGetters = {
  contactGroups: (state) => state.contactGroups,
  selectedContactGroup: (state) => state.selectedContactGroup,
  selectedContactGroupLoading: (state) => state.selectedContactGroupLoading,
  contactGroupDetails: (state) => state.contactGroupDetails,
}